import { render, staticRenderFns } from "./m_AllInterpretationSkills.vue?vue&type=template&id=f6a2fd70&scoped=true&"
import script from "./m_AllInterpretationSkills.vue?vue&type=script&lang=js&"
export * from "./m_AllInterpretationSkills.vue?vue&type=script&lang=js&"
import style0 from "./m_AllInterpretationSkills.vue?vue&type=style&index=0&id=f6a2fd70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a2fd70",
  null
  
)

export default component.exports